import { Modal } from '../../../../../components/Modal/Modal'
import { ReactComponent as Magnifier } from '../../../../../assets/images/magnifier.svg'
import { ReactComponent as Arrow } from '../../../../../assets/images/arrow.svg'
import React, { useState } from 'react'
import './FindAndReplaceModal.scss'
import { FormControl } from 'react-bootstrap'

const MAX_INPUT_LENGTH = 50
const MAX_INPUT_LENGTH_ERROR = `Too long - ${MAX_INPUT_LENGTH} characters max`

export interface FindAndReplaceModalProps {
  show: boolean
  onHide: () => void
  handleFindAndReplaceClicked: (find: string, replace: string) => void
}

export const FindAndReplaceModal: React.FC<FindAndReplaceModalProps> = ({ handleFindAndReplaceClicked, show, onHide }) => {
  const [findValue, setFindValue] = useState<string>('')
  const [replaceValue, setReplaceValue] = useState<string>('')

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const onFindAndReplaceClicked = async () => {
    setIsLoading(true)

    handleFindAndReplaceClicked(findValue, replaceValue)
  }

  const modalHeader = (
    <div className='d-flex justify-content-between align-items-center'>
      <h5 className='fs-4 zocks-px-0.25'>Find and Replace</h5>
    </div>
  )

  const modalBody = (
    <div className='d-flex flex-column zocks-gap-1 pt-4'>
      <div className='paragraph-medium-extended'>Find and replace text across Meeting Summary, Presets, Forms, and Tasks.</div>
      <ul className='mb-2 ps-4'>
        <li>Only exact matches will be replaced.</li>
        <li>Use short phrases (50 characters max) – for longer changes, edit content directly.</li>
      </ul>
      <div>
        <div className='input-group d-flex align-items-center justify-content-between rounded border zocks-border-color-gray-400 bg-white zocks-color-gray-400 ps-2 input-hover'>
          <Magnifier />
          <FormControl
            id='findInput'
            type='text'
            value={findValue}
            onChange={(e) => setFindValue(e.target.value)}
            className='border-0'
            placeholder='Enter text to find'
          />
        </div>
        {findValue.length > MAX_INPUT_LENGTH && <div className='text-danger small'>{MAX_INPUT_LENGTH_ERROR}</div>}
      </div>
      <div>
        <div className='input-group d-flex align-items-center justify-content-between rounded border zocks-border-color-gray-400 bg-white zocks-color-gray-400 ps-2 input-hover'>
          <Arrow />
          <FormControl
            id='replaceInput'
            type='text'
            value={replaceValue}
            onChange={(e) => setReplaceValue(e.target.value)}
            className='border-0'
            placeholder='Enter text to replace with'
          />
        </div>
        {replaceValue.length > MAX_INPUT_LENGTH && <div className='text-danger small'>{MAX_INPUT_LENGTH_ERROR}</div>}
      </div>
    </div>
  )

  return (
    <Modal
      onHide={onHide}
      show={show}
      header={modalHeader}
      body={modalBody}
      showFooterActions={true}
      onFooterPrimaryAction={onFindAndReplaceClicked}
      footerPrimaryActionTitle='Replace all'
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionDisabled={isLoading || !findValue.trim() || findValue.length > MAX_INPUT_LENGTH || replaceValue.length > MAX_INPUT_LENGTH}
      onFooterSecondaryAction={onHide}
      footerSecondaryActionTitle='Cancel'
      bodyClassName='border-top'
    ></Modal>
  )
}
